import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Select as AntSelect } from 'antd';

/**
 * Reusable design-system wrapper around Ant Design Select.
 * Adds a stable class hook while retaining the native Ant Design API.
 */
const Select = forwardRef(({
    className = '',
    contentSizedPopup = false,
    popupMatchSelectWidth,
    ...props
}, ref) => {
    const classNames = className.split(/\s+/).filter(Boolean);
    const resolvedPopupMatchSelectWidth = popupMatchSelectWidth
        ?? (contentSizedPopup ? false : undefined);

    return (
        <AntSelect
            ref={ref}
            className={['ds-select', ...classNames].join(' ')}
            popupMatchSelectWidth={resolvedPopupMatchSelectWidth}
            {...props}
        />
    );
});

Select.displayName = 'Select';
Select.Option = AntSelect.Option;
Select.OptGroup = AntSelect.OptGroup;

Select.propTypes = {
    className: PropTypes.string,
    contentSizedPopup: PropTypes.bool,
    popupMatchSelectWidth: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number,
    ]),
};

export default Select;
